import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactSection from './components/ContactSection';
import SeoHead from '@/components/base/SeoHead';

export default function ContactPage() {
  const [scrolled, setScrolled] = useState(false);
  const { i18n } = useTranslation();
  const isTR = i18n.language === 'tr' || i18n.language?.startsWith('tr');

  const seo = isTR
    ? {
        title: 'İletişim | OKAYISU LED Aydınlatma İstanbul | Ücretsiz Teklif',
        description: 'OKAYISU LED aydınlatma için iletişim bilgileri. İstanbul Şişli Perpa Ticaret Merkezi. Ücretsiz keşif ve proje teklifi alın. Telefon: +90 212 220 52 56. E-posta: info@okayisu.com',
        keywords: 'OKAYISU iletişim, LED aydınlatma teklif, İstanbul aydınlatma firması iletişim, ücretsiz keşif',
        canonicalUrl: 'https://www.okayisu.com/iletisim',
        lang: 'tr',
      }
    : {
        title: 'Contact | OKAYISU LED Lighting Istanbul | Free Quote',
        description: 'Contact OKAYISU for LED lighting projects. Free site survey and quotation. Address: Perpa Trade Center, Şişli, Istanbul. Phone: +90 212 220 52 56. Email: info@okayisu.com',
        keywords: 'OKAYISU contact, LED lighting quote, Istanbul lighting company, free consultation, project inquiry',
        canonicalUrl: 'https://www.okayisu.com/en/iletisim',
        lang: 'en',
      };

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: isTR ? 'OKAYISU LED Aydınlatma İletişim' : 'OKAYISU LED Lighting Contact',
    description: seo.description,
    url: seo.canonicalUrl,
    about: {
      '@type': 'Organization',
      name: 'OKAYISU Aydınlatma San. İç ve Dış Tic. Ltd. Şti.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Perpa Ticaret Merkezi A Blok Kat:5 No:204',
        addressLocality: 'İstanbul',
        addressRegion: 'Şişli',
        postalCode: '34384',
        addressCountry: 'TR',
      },
      telephone: '+90-212-220-52-56',
      email: 'info@okayisu.com',
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    },
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <SeoHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        lang={seo.lang}
        structuredData={structuredData}
      />
      <Navbar />
      <div className="pt-20">
        <ContactHero />
      </div>
      <ContactSection />
      <Footer />
    </div>
  );
}